export enum ScrollSizeEnum {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
  FULL = 'full',
  AUTO = 'auto'
}

export type ScrollSizeEnumValues = `${ScrollSizeEnum}`;
